import { Button } from '@chakra-ui/react'
import React from 'react'
import { Title } from '../Components/Atoms'
import { AddModelIcon } from '../Assets/images/svgs'

const NoDataWidget = ({ heading="", icon: Icon, info, showBtn, btnTitle, onClick = () => { }}) => {

  return (
    <>
      <article className="widget-main-nodata">
        <header className="widget-header">
          <Title variant="md" fixed>{heading}</Title>
        </header>

        <div className='widget-nodata-section'>
          {Icon && <Icon />}
          <h1>{info}</h1>
          {
            showBtn && <Button
              leftIcon={<AddModelIcon />}
              variant="solid"
              onClick={onClick}
            >
              { btnTitle }
            </Button>
          }
        </div>
      </article>
    </>
  )
}

export default NoDataWidget;